import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Link, useNavigate } from "react-router-dom";
import PaginationComponent from "../../../Components/PaginationComponent";
import toast from "react-hot-toast";
import medicineService from "../../../Services/medicineService";

const MedicineStock = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const getStock = async () => {
      try {
        setLoading(true);
        const response = await medicineService.fetchAll();
        setPatients(response.medicines);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching Medicines");
      }
    };
    getStock();
  }, []);

  useEffect(() => {
    const filteredResult =
      patients?.filter((item) =>
        item?.medicine_name?.toLowerCase().includes(searchData.toLowerCase())
      ) || [];
    setFilteredData(filteredResult);
    setCurrentPage(1);
  }, [searchData, patients]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
  }, [currentPage, filteredData]);

  return (
    <div className="p-3 sm:p-6">

      <div className="bg-white border border-gray-200 rounded-xl px-4 sm:px-6 py-4 mb-4 sm:mb-5 shadow-sm">

        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">

  <div>
    <h1 className="text-[15px] sm:text-[17px] font-[500] text-gray-800 leading-tight">
      Medicine Stock
    </h1>
    <p className="text-[11px] sm:text-[12px] text-gray-400 mt-0.5">
      {filteredData?.length || 0} records found
    </p>
  </div>

  <div className="flex items-center gap-2 w-full sm:w-auto">

    <div className="relative flex-1 sm:flex-none">
      <SearchIcon
        className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
        style={{ fontSize: 16 }}
      />
      <input
        type="search"
        placeholder="Search by name..."
        value={searchData}
        onChange={(e) => setSearchData(e.target.value)}
        className="pl-8 pr-3 py-[7px] w-full sm:w-[230px] text-[13px] bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-[#2F6DB4]/30"
      />
    </div>

    <Link to="purchasemedicine" className="flex-shrink-0">
      <button className="whitespace-nowrap bg-[#2F6DB4] text-white text-[13px] font-[500] px-3 sm:px-4 py-2 rounded-lg shadow-md hover:shadow-gray-200 hover:scale-[1.03] active:scale-[0.97] transition-all duration-300">
        + Medicine
      </button>
    </Link>

  </div>
</div>

    
      </div>

      <div className="hidden sm:block bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[540px]">
            <thead>
              <tr className="bg-[#2F6DB4] text-[11px] uppercase text-white">
                <th className="py-3 px-4 text-left">ID</th>
                <th className="py-3 px-4 text-left">Name</th>
                <th className="py-3 px-4 text-center">Qty</th>
                <th className="py-3 px-4 text-center">Price</th>
                <th className="py-3 px-4 text-center">Supplier Name</th>
                <th className="py-3 px-4 text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={6} className="py-10 text-center text-gray-400 text-[13px]">
                    Loading...
                  </td>
                </tr>
              ) : paginatedData?.length === 0 ? (
                <tr>
                  <td colSpan={6} className="py-10 text-center text-gray-400 text-[13px]">
                    No records found
                  </td>
                </tr>
              ) : (
                paginatedData?.map((patient) => (
                  <tr key={patient?.id} className="border-t hover:bg-gray-50 text-[13px]">
                    <td className="py-3 px-4 text-gray-500">{patient?.id}</td>
                    <td className="py-3 px-4 font-[500] text-gray-800">{patient?.medicine_name}</td>
                    <td className="py-3 px-4 text-center text-gray-600">{patient?.quantity_in_stock}</td>
                    <td className="py-3 px-4 text-center text-gray-600">{patient?.price}</td>
                    <td className="py-3 px-4 text-center text-gray-600">{patient?.supplier_name}</td>
                    <td className="py-3 px-4 text-center">
                      <button
                        onClick={() => navigate(`purchasemedicine/${patient.id}`)}
                        className="bg-blue-50 text-blue-600 text-[12px] px-3 py-1 rounded-md hover:bg-blue-100 transition-colors"
                      >
                        Update
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="sm:hidden space-y-2.5">
        {loading ? (
          <div className="bg-white border border-gray-200 rounded-xl py-10 text-center text-gray-400 text-[13px] shadow-sm">
            Loading...
          </div>
        ) : paginatedData?.length === 0 ? (
          <div className="bg-white border border-gray-200 rounded-xl py-10 text-center text-gray-400 text-[13px] shadow-sm">
            No records found
          </div>
        ) : (
          paginatedData?.map((patient) => (
            <div
              key={patient?.id}
              className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm"
            >
              <div className="flex items-start justify-between gap-2 mb-3">
                <div className="min-w-0 flex-1">
                  <span className="text-[10px] font-bold text-[#2F6DB4] uppercase tracking-wide">
                    ID #{patient?.id}
                  </span>
                  <p className="text-[14px] font-[600] text-gray-800 mt-0.5 leading-tight truncate">
                    {patient?.medicine_name}
                  </p>
                </div>
                <button
                  onClick={() => navigate(`purchasemedicine/${patient.id}`)}
                  className="flex-shrink-0 bg-blue-50 text-blue-600 text-[11px] px-2.5 py-1 rounded-md hover:bg-blue-100 transition-colors"
                >
                  Update
                </button>
              </div>

              <div className="grid grid-cols-3 gap-2">
                {[
                  { label: "Qty", value: patient?.quantity_in_stock },
                  { label: "Price", value: patient?.price },
                  { label: "Supplier", value: patient?.supplier_name },
                ].map(({ label, value }) => (
                  <div key={label} className="bg-gray-50 rounded-lg px-2.5 py-2">
                    <p className="text-[10px] text-gray-400 font-[500] uppercase tracking-wide mb-0.5">
                      {label}
                    </p>
                    <p className="text-[13px] font-[600] text-gray-700 truncate">
                      {value ?? "—"}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </div>

      <PaginationComponent
        filteredData={filteredData}
        setPaginatedData={setPaginatedData}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};

export default MedicineStock;